let arr=[
    {name:'总经理',value:'总经理'},
    {name:'联系人',value:'联系人'}
]
export default arr